import { Component, computed, input, output } from '@angular/core';
import { UiTableUser } from '@features/users/interfaces';
import { TableToolbarButton, TableToolbarComponent, ToolbarAction } from '@shared';
import { FilterOption } from '@shared/components/filter-dropdown/filter-dropdown.component';

@Component({
    selector: 'app-users-toolbar',
    imports: [TableToolbarComponent],
    templateUrl: './user-app-toolbar.component.html',
    styleUrl: './user-app-toolbar.component.scss',
})
export class UserAppToolbarComponent {
    /**
     * User controls
     */
    protected readonly controlsButtons: TableToolbarButton[] = [];

    /**
     * Selected users as input. This allows us to enable/disable the delete button if no user is selected
     */
    public selection = input.required<UiTableUser[]>();

    /**
     * Filter by dropdown options
     */
    public filterDropdownOptions = input<FilterOption[]>([]);

    /**
     * Emit the debounced search key
     */
    public searchChange = output<string>();

    /**
     * Emit selected date range
     */
    public dateRangeChange = output<{ start: Date; end: Date }>();

    /**
     * Emit toolbar action change
     */
    public toolbarActionChange = output<ToolbarAction>();

    /**
     * Emit filter by option change
     */
    public filterByOptionChange = output<string>();

    /**
     * Reactive toolbar buttons
     */
    protected toolbarButtons = computed(() => {
        const selections = this.selection();
        return this.controlsButtons.map((btn) => {
            return {
                ...btn,
                disabled: btn.variant === 'danger' && selections.length <= 1,
            };
        });
    });

    /**
     * On talble toolbar action  click (the button or controls above the table)
     * @param {string} name The name of the event
     */
    protected onToolbarAction(name: string): void {
        switch (name) {
            case 'Bulk Delete':
                this.toolbarActionChange.emit(ToolbarAction.BULK_DELETE);
                break;
            case 'Export':
                this.toolbarActionChange.emit(ToolbarAction.EXPORT);
                break;
            default:
                break;
        }
    }

    /**
     * On search change, triggers after a the set debounce time in the table toolbar component
     * @param {string} value The value of the search input
     */
    protected onSearchValueChange(value: string): void {
        this.searchChange.emit(value);
    }

    /**
     * On date range picker dates change
     * @param {{start: Date, end: Date}} dates selected in the date range picker
     */
    protected onDatesChange(dates: { start: Date; end: Date }): void {
        this.dateRangeChange.emit(dates);
    }
}
